import {
  FETCH_COMMERCIAL_MANAGEMENT_REQUEST,
  FETCH_COMMERCIAL_MANAGEMENT_SUCCESS,
  FETCH_COMMERCIAL_MANAGEMENT_ERROR,
  FETCH_COMMERCIAL_MANAGEMENT_REPORT_ERROR,
  FETCH_COMMERCIAL_MANAGEMENT_REPORT_REQUEST,
  FETCH_COMMERCIAL_MANAGEMENT_REPORT_SUCCESS
} from 'actionTypes'

const DEFAULT_STATE = {
  record: {},
  reportRecord: {},
  reportError: null,
  error: null,
  isFetching: false,
  filters: {},
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {


    case FETCH_COMMERCIAL_MANAGEMENT_REPORT_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_COMMERCIAL_MANAGEMENT_REPORT_ERROR: {
      return {
        ...state,
        isFetching: false,
        reportError: action.payload,

      }
    }

    case FETCH_COMMERCIAL_MANAGEMENT_REPORT_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        reportRecord: action.payload,
        reportError: null,
      }
    }

    case FETCH_COMMERCIAL_MANAGEMENT_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_COMMERCIAL_MANAGEMENT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        record: action.payload,
        filters: action.filters,
      }

    case FETCH_COMMERCIAL_MANAGEMENT_ERROR:
      return {
        ...state,
        isFetching: false,
        record: {},
        error: action.payload,
        filters: action.filters,
      }

    default:
      return state
  }
}

export default record
